import request from '@/api/request'

// 下载模板
export function importTemplate() {
  return request({
    url: `/system/service/con/importTemplate`,
    method: 'post',
    responseType: 'blob'
  })
}

// 获取服务项目列表
export function listService(params) {
  return request({
    url: `/system/service/con/list`,
    method: 'get',
    params
  })
}

// 新增服务项目
export function addService(data) {
  return request({
    url: `/system/service/con/list`,
    method: 'post',
    data
  })
}

// 修改服务项目
export function updateService(data) {
  return request({
    url: `/system/service/con/list`,
    method: 'put',
    data
  })
}

// 删除服务项目
export function delService(id) {
  return request({
    url: `/system/service/con/list/${id}`,
    method: 'delete'
  })
}

// 查询服务项目
export function getService(id) {
  return request({
    url: `/system/service/con/list/${id}`,
    method: 'get'
  })
}

// 查询下拉服务项目
export function getItem(category, type) {
  return request({
    url: `/system/service/con/list/item`,
    method: 'get',
    params: { category: category, type: type }
  })
}

// 查询房间号数据
export function getLocationList(type) {
  return request({
    url: `/ticket/config/areaList`,
    method: 'get',
    params: { type: type }
  })
}

// 查询指定房间数据
export function getRoomById(id) {
  return request({
    url: `/ticket/config/area/${id}`,
    method: 'get'
  })
}